import api from './api';

export const authService = {
  // Login user
  login: async (email: string, password: string) => {
    // Use Django users/token/ endpoint
    const response = await api.post('users/token/', { email, password });
    if (response.data?.access && response.data?.refresh) {
      localStorage.setItem('access_token', response.data.access);
      localStorage.setItem('refresh_token', response.data.refresh);
      return response.data;
    }
    throw new Error('Login failed: missing tokens');
  },

  // Register user
  register: async (userData: {
    email: string;
    first_name: string;
    last_name: string;
    password: string;
    password2: string;
    phone_number?: string;
    address?: string;
    city?: string;
    country?: string;
    postal_code?: string;
  }) => {
    const response = await api.post('users/register/', userData);
    return response.data;
  },

  // Get current user
  getCurrentUser: async () => {
    const response = await api.get('users/profile/');
    return response.data;
  },

  // Update user profile
  updateProfile: async (userData: {
    first_name?: string;
    last_name?: string;
    email?: string;
  }) => {
    const response = await api.patch('users/profile/', userData);
    return response.data;
  },

  // Change password
  changePassword: async (passwordData: {
    old_password: string;
    new_password: string;
    new_password2: string;
  }) => {
    const response = await api.put('users/change-password/', passwordData);
    return response.data;
  },

  // Request password reset
  requestPasswordReset: async (email: string) => {
    const response = await api.post('users/password-reset/', { email });
    return response.data;
  },

  // Confirm password reset
  confirmPasswordReset: async (data: {
    uid: string;
    token: string;
    new_password: string;
    new_password2: string;
  }) => {
    const response = await api.post('users/password-reset/confirm/', data);
    return response.data;
  },

  // Logout
  logout: () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('access_token');
  },

  // Refresh token
  refreshToken: async () => {
    const refreshToken = localStorage.getItem('refresh_token');
    if (!refreshToken) {
      throw new Error('No refresh token available');
    }

    const response = await api.post('users/token/refresh/', {
      refresh: refreshToken,
    });

    const { access } = response.data;
    localStorage.setItem('access_token', access);
    return access;
  },
};